import { useAppTFunction } from '@retail/app/i18n';
import { bulkEditPricesSchema, PriceItemSchema } from '@retail/my-assortment/components';
import { AssortmentPrices } from '@retail/my-assortment/types';
import { useCallback, useState } from 'react';
import { useConditionActions } from '@retail/calculus/context';
import { BulkEditSalesPricesDialog } from './BulkEditSalesPricesDialog';
import { UniversalFormProvider } from '@shared/components';

interface Props {
  assortmentItems: AssortmentPrices[];
  includeVat: boolean;
  onClose: () => void;
}

export function BulkEditSalesPriceDialogContainer({ assortmentItems, includeVat, onClose }: Props) {
  const t = useAppTFunction();

  const [itemsForEdit, updateItemsForEdit] = useState<AssortmentPrices[]>(assortmentItems);

  const { createMultipleConditions } = useConditionActions();

  const handleRemoveItem = useCallback(
    (itemId: number) =>
      updateItemsForEdit(itemsForEdit.filter((item) => item.mgSupplierItemId !== itemId)),
    [itemsForEdit]
  );

  const defaultItemsValues: Record<string, PriceItemSchema> = Object.fromEntries(
    assortmentItems.map((item) => [
      item.mgSupplierItemId + '',
      { fromDate: new Date(), primaryUnit: item.primaryUnit, salesPrice: null },
    ])
  );

  return (
    <UniversalFormProvider
      schema={bulkEditPricesSchema(t)}
      defaultValues={{ items: defaultItemsValues }}
    >
      <BulkEditSalesPricesDialog
        itemsForEdit={itemsForEdit}
        includeVat={includeVat}
        createMultipleConditions={createMultipleConditions}
        handleRemoveItem={handleRemoveItem}
        onClose={onClose}
      />
    </UniversalFormProvider>
  );
}
